import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RequestsRoutingModule } from './requests-routing.module';
import { RequestsComponent } from './requests.component';
import { RequestAddComponent } from './create/request_add.component';
import { RequestReturnComponent } from './return/return.component';
import { RequestConfirmComponent } from './confirm/confirm.component';
import { FileUploadModule } from '../fileUpload.module';
import { TranslateModule } from 'ng2-translate';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RequestsRoutingModule,
        FileUploadModule,
        TranslateModule
    ],
    declarations: [
        RequestsComponent,
        RequestAddComponent,
        RequestReturnComponent,
        RequestConfirmComponent,
    ],
    exports: [
        
    ]
})

export class RequestsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/requests.module.ts